import { styled } from '@mui/system';

export const KeyValuePair = styled('div')`
	display: flex;
	flex-direction: column;
	word-wrap: break-word;
	padding-right: 20px;
`;
